import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
    attributeName: 'change',
    isDragable: false,
    canOpen: false,
    canEdit: false,
    canCreate: false,
    canRemove: false,
    isSelectable: true,
    isMultiSelectable: true,
    emptyMessage: "You don't have contents, visit the content section to create one.",
    getURL: 'audit/uuid/change',
    fields: [
    ],
}